import ApiService from './api.service';
import type { ListRecordsResponse, SingleRecordResponse } from './pipelineNode.service';

export type { ListRecordsResponse };

export interface UnstructuredContextItem {
  id: string;
  user_id: string;
  created_at: string;
  title: string;
  keywords: string[];
  body: string;
}

export class UnstructuredContextService {
  async find(options?: {
    page?: number;
    pageSize?: number;
    filters?: Record<string, any>;
  }): Promise<ListRecordsResponse<UnstructuredContextItem>> {
    const {
      page = 1,
      pageSize = 50,
      filters = {},
    } = options || {};

    const queryParams: Record<string, any> = {
      page,
      limit: pageSize,
      ...filters,
    };

    const result = await ApiService.getInstance().request(
      'GET',
      '/unstructuredcontexts',
      queryParams
    ) as ListRecordsResponse<UnstructuredContextItem>;

    return result;
  }

  async findById(id: string): Promise<UnstructuredContextItem> {
    const result = await ApiService.getInstance().request(
      'GET',
      `/unstructuredcontexts/${id}`
    ) as SingleRecordResponse<UnstructuredContextItem>;
    return result.record;
  }

  async save(item: Partial<UnstructuredContextItem>): Promise<UnstructuredContextItem> {
    const result = await ApiService.getInstance().request(
      'PATCH',
      `/unstructuredcontexts/${item.id}`,
      item
    ) as SingleRecordResponse<UnstructuredContextItem>;
    return result.record;
  }

  async create(item: Partial<UnstructuredContextItem>): Promise<UnstructuredContextItem> {
    const result = await ApiService.getInstance().request(
      'POST',
      '/unstructuredcontexts',
      item
    ) as SingleRecordResponse<UnstructuredContextItem>;
    return result.record;
  }

  async delete(id: string): Promise<void> {
    await ApiService.getInstance().request(
      'DELETE',
      `/unstructuredcontexts/${id}`
    );
  }
}

export const unstructuredContextService = new UnstructuredContextService();
